import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Maisons from "../views/Maisons.vue";
import Reservations from "../views/Reservations.vue";
import Campements from "../views/Campements.vue";
import RTL from "../views/Rtl.vue";
import Paiements from "../views/Paiements.vue";
import Signin from "../views/Signin.vue";
import ExcursionCircuits from "../views/ExcursionCircuits.vue";

// Function to get cookie value
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// Function to check if authenticated
function isAuthenticated() {
  return !!getCookie('accessToken');
}

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/tableau-de-bord",
    name: "Tableau de bord",
    component: Dashboard,
  },
  {
    path: "/maisons-dhotes",
    name: "Maisons d'hôtes",
    component: Maisons,
  },
  {
    path: "/reservations",
    name: "Réservations",
    component: Reservations,
  },
  {
    path: "/campements",
    name: "Campements",
    component: Campements,
  },
  {
    path: "/circuits-d-excursion",
    name: "Circuits d'excursion",
    component: ExcursionCircuits,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/paiements",
    name: "Paiements",
    component: Paiements,
  },
  {
    path: "/login",
    name: "Signin",
    component: Signin,
  },
 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Route guard
router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !isAuthenticated()) {
    next('/login');
  } else {
    next();
  }
});

export default router;
